import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the Vendors state domain
 */

const selectVendorsDomain = state => state.vendors || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by EasySplitVendors
 */

const makeSelectVendors = () =>
  createSelector(
    selectVendorsDomain,
    substate => substate,
  );

export default makeSelectVendors;
export { selectVendorsDomain };
